export default {
  'mission.title': 'Mission Management',
  'mission.tabs.rewards': 'Mission Rewards',
  'mission.tabs.configs': 'System Configs (Popup, URL)',
  'mission.alert.title': 'Configuration Center',
  'mission.alert.desc': 'Manage system operating parameters such as Popup content, URLs, and Logic parameters.',
  'mission.col.mission': 'Mission',
  'mission.col.desc': 'Description',
  'mission.col.reward': 'Reward',
  'mission.col.status': 'Status',
  'mission.col.action': 'Action',
  'mission.col.key': 'Key',
  'mission.col.value': 'Value',
  'mission.btn.edit': 'Edit',
  'mission.btn.cancel': 'Cancel',
  'mission.btn.save': 'Save',
  'mission.btn.update': 'Update',
  'mission.drawer.reward.title': 'Reward Configuration',
  'mission.drawer.config.title': 'Update Configuration',
  'mission.form.rewardValue': 'Reward Value (COWe)',
  'mission.form.required': 'Please enter the amount',
  'mission.form.activeStatus': 'Active Status',
  'mission.form.on': 'On',
  'mission.form.off': 'Off',
  'mission.form.systemKey': 'System Key',
  'mission.form.copySuccess': 'Key copied!',
  'mission.form.noDesc': 'No description',
  'mission.form.switchValue': 'Switch Value (On/Off)',
  'mission.form.configContent': 'Configuration Content',
  'mission.form.valueRequired': 'Please enter a value',
  'mission.form.jsonStructure': 'JSON STRUCTURE (ONLY EDIT VALUES)',
  'mission.msg.loadError': 'Error loading data',
  'mission.msg.updateSuccess': 'Update successful',
  'mission.msg.updateError': 'Error updating',
  'mission.msg.toggleSuccess': '{status} mission {key}',
};
